import React from 'react';
import { DollarSign } from 'lucide-react';
import ComingSoon from '../components/ComingSoon';

const QuoteChecker = () => {
  return (
    <ComingSoon
      featureName="Quote Checker"
      description="Compare and validate contractor quotes against market standards. Our intelligent system analyzes pricing trends, identifies potential overcharges, and ensures you're getting fair market rates for your construction project."
      icon={DollarSign}
    />
  );
};

export default QuoteChecker;
